export default "__VITE_ASSET__u0NU0rkj__"